import React from "react";
import { useTranslation } from "react-i18next";
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  useMediaQuery,
} from "@mui/material";
import { ReactComponent as SelectArrow } from "../../../../assets/profile/icons/selectBlueIcon.svg";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { statuses } from "../../constants";

export const AffiliatesStatusSelect = ({
  initLeadStatus,
  onLeadStatusChange,
}: {
  initLeadStatus: string;
  onLeadStatusChange: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { i18n, t } = useTranslation(["profile"]);
  const isRTL = i18n.dir() === "rtl";
  const langTheme = useLanguageTheme();
  const is970px = useMediaQuery("(max-width: 970px)");

  const initialSelectedOption = React.useMemo(() => {
    const matchedOption = statuses.find(
      (option) => option.nameParam === initLeadStatus
    );

    return matchedOption || statuses[0];
  }, [initLeadStatus, statuses]);

  const [selectedOption, setSelectedOption] = React.useState<any>(
    initialSelectedOption
  );

  React.useEffect(() => {
    setSelectedOption(initialSelectedOption);
  }, [initialSelectedOption]);

  const handleChangeOption = (event: SelectChangeEvent<string>) => {
    const selected = statuses.find(
      (option) => option.id.toString() === event.target.value
    );

    if (!selected) {
      return;
    }

    setSelectedOption(selected);
    onLeadStatusChange(selected.nameParam);
  };

  return (
    <Select
      fullWidth
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              background: "rgba(255, 255, 255, 1)",
              maxWidth: is970px ? "100%" : "248px",
              width: "100%",
            },
          },
        },
      }}
      sx={{
        direction: i18n.dir(),
        maxWidth: is970px ? "100%" : "248px",
        width: "100%",
        minWidth: "190px",
        border: "1px solid rgba(224, 229, 242, 1)",
        borderRadius: "16px",
        fontWeight: 500,
        fontSize: "14px",
        color: "rgba(43, 54, 116, 1)",
        fontFamily: langTheme.mainFont(),
        height: "50px",
        boxSizing: "border-box",
        "& .MuiSelect-select": {
          padding: "14.5px 18px",
          fontSize: "14px",
          color: "rgba(43, 54, 116, 1)",
        },
        "& .MuiSelect-icon": {
          top: "calc(50% - 0.2em)",
          right: isRTL ? "auto" : "20px",
          left: isRTL ? "20px" : "auto",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .MuiOutlinedInput-input": {
          paddingRight: 0,
        },
      }}
      value={selectedOption.id.toString()}
      onChange={handleChangeOption}
      IconComponent={SelectArrow}
    >
      {statuses.map((status, index: number) => (
        <MenuItem
          value={status.id.toString()}
          key={status.id}
          sx={{
            color: "rgba(43, 54, 116, 1)",
            fontFamily: langTheme.mainFont(),
            fontWeight: 500,
            fontSize: "14px",
            direction: i18n.dir(),
            "&:hover": {
              backgroundColor: "#3989d714",
            },
          }}
        >
          {/* {t(status.name)} */}
          {t(status.nameParam)}
        </MenuItem>
      ))}
    </Select>
  );
};
